module.exports = __webpack_public_path__ + "img/banner1.3a26c88c.png";